<template>
  <div style="height: 100vh" class="body-img Fontst">
    <div class="bge">
      <div class="div_row">
        <div class="div_logo">
          <img
            style="width: 65%"
            src="../../../../assets/images/background/sentenance_logoW (1).png"
            alt=""
          />
        </div>
      </div>
      <div class="div_row">
        <div class="div_left">
          <div
            style="width: 100%; position: relative"
            class="forresponsive div_left_main"
          >
            <ul class="nonelist">
              <li>
                <vs-row
                  ><h1 class="colorw Fontst">Sign</h1>
                  <h1 class="colorgreen ml-2">In</h1></vs-row
                >
              </li>
              <li>
                <div class="form fontnormal">
                  <div class="input-container ic1">
                    <input
                      id="firstname"
                      class="input"
                      type="text"
                      placeholder=" "
                    />

                    <label for="firstname" class="placeholder">Username</label>
                  </div>
                  <div class="input-container ic2">
                    <input
                      id="lastname"
                      class="input"
                      type="password"
                      placeholder=" "
                    />

                    <label for="lastname" class="placeholder">Password</label>
                  </div>
                </div>
              </li>
              <br />
              <li class="mt-2">
                <vs-row>
                  <input
                    class="mr-2 colorgreen"
                    type="checkbox"
                    checked="checked"
                  />
                  <h6 class="colorw">Remember me</h6>
                  <vs-spacer />
                  <h6 class="colorgray forgotpass">Forgot password</h6></vs-row
                >
              </li>
              <br />
              <li class="mt-2">
                <vs-row vs-type="flex" vs-justify="center" vs-align="center">
                  <vs-button class="widthbtm mr-6" color="success" type="filled"
                    ><h4>Login</h4></vs-button
                  ><vs-button
                    class="widthbtm ml-3"
                    color="success"
                    type="border"
                    ><h4>Sign up</h4></vs-button
                  ></vs-row
                >
              </li>
              <li>
                <div
                  style="
                    text-align: center;

                    margin-top: 15%;
                  "
                >
                  <p class="colorw">
                    By clicking "Sign In" you agree to Sentenance's <br />
                    <a href="">Terms Of Service</a> and
                    <a href="">Privacy Policy</a>
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="div-wrapperimg">
            <img src="../../../../assets/images/background/Group 10469.png" />
          </div>
        </div>
        <div class="div_right">
          <div>
            <br />

            <vs-row>
              <vs-col vs-type="flex" vs-align="center" vs-w="12">
                <ul class="nonelist">
                  <li>
                    <vs-row style="display: flex; align-items: baseline">
                      <h3 class="colorw Fontst">
                        Think of your own IoT facility management.
                      </h3>
                      <h1 style="font-size: 300%" class="colorgreen Fontst">
                        <b> Think Sentenance</b>
                      </h1>
                    </vs-row>
                  </li>
                  <li class="mt-2">
                    <h4 class="colorw Fontst">
                      The most flexible IoT wireless sensor and facility
                      automation system.
                    </h4>
                  </li>
                </ul>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="right"
                vs-align="center"
                vs-w="12"
              >
                <img
                  style="width: 70%"
                  src="../../../../assets/images/background/Group 10469.png"
                  alt=""
                />
              </vs-col>
            </vs-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Charm:wght@700&family=Roboto:wght@100&display=swap");
.Fontst {
  font-family: "Roboto", sans-serif;
}
.fontnormal {
  font-size: 1rem;
}
.body-img {
  /* height: 100%; */
  margin: 0;
}
.bge {
  /* The image used */
  background-image: url("../../../../assets/images/background/SpaceDrive – 2.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.colorgreen {
  color: #32c040;
}
.colorw {
  color: #ffffff;
}
.colorgray {
  color: #a7a7af;
}
.forgotpass:hover {
  color: #32c040;
  cursor: pointer;
}
.mr-6 {
  margin-right: 10%;
}
.widthbtm {
  width: 40%;
}
.nonelist {
  list-style-type: none;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  color: #32c040;
}
/* input[type="password"] {
  width: 100%;
  padding: 12px 10px;
  margin: 8px 0;
  box-sizing: border-box;
  border: none;
  color: #32c040;
  border-bottom: 1px solid #ffffff;
  background-color: transparent;
}
input[type="text"] {
  width: 100%;
  padding: 12px 10px;
  margin: 8px 0;
  box-sizing: border-box;
  border: none;
  color: #32c040;
  border-bottom: 1px solid #ffffff;
  background-color: transparent;
}
input[type="text"]:focus {
  width: 100%;
  padding: 12px 10px;
  margin: 8px 0;
  box-sizing: border-box;
  border: none;
  color: #ffffff;
  border-bottom: 1px solid #32c040;
  background-color: transparent;
} */

.input-container {
  position: relative;
  width: 100%;
}

.ic1 {
  margin-top: 7%;
}

.ic2 {
  margin-top: 7%;
}

.input {
  width: 100%;
  padding: 12px 10px;
  margin: 8px 0;
  box-sizing: border-box;
  border: none;
  color: #32c040;
  border-bottom: 1px solid #ffffff;
  background-color: transparent;
}
.input:focus {
  color: #ffffff;
  border: 1px solid #32c040;
}

.placeholder {
  color: #32c040;
  left: 0;
  line-height: 14px;
  pointer-events: none;
  position: absolute;
  transform-origin: 0 50%;
  transition: transform 200ms, color 200ms;
  top: 20px;
}

.input:focus ~ .placeholder,
.input:not(:placeholder-shown) ~ .placeholder {
  transform: translateY(-30px) translateX(2px) scale(0.75);
}

.input:not(:placeholder-shown) ~ .placeholder {
  /* color: #808097; */
  font-size: 1.2rem;
  color: #ffffff;
}

.input:focus ~ .placeholder {
  color: #32c040;
  font-size: 1.2rem;
}

input[type="checkbox"] {
  filter: invert(20%) hue-rotate(250deg) brightness(1.3);
}
::-webkit-input-placeholder {
  /* Edge */
  color: #32c040;
}

:-ms-input-placeholder {
  /* Internet Explorer */
  color: #32c040;
}

::placeholder {
  color: #32c040;
}
.div_row {
  display: flex;
  width: 100%;
  flex-flow: wrap;
}
.div_left {
  justify-content: left;
  display: flex;
  margin-left: 0%;
  width: 40%;
}
.div_right {
  justify-content: left;
  display: flex;
  align-items: center;
  margin-left: 0%;
  width: 60%;
}
.div_left_main {
  padding: 5% 20% 0% 20%;
}
.div_logo {
  justify-content: center;
  display: flex;
  align-items: center;
  margin-left: 0%;
  width: 50%;
  margin-top: 3%;
}
.div-wrapperimg img {
  display: none;
}
@media only screen and (max-width: 1200px) {
  .bge {
    /* The image used */
    background-image: url("../../../../assets/images/background/SpaceDrive – 2.png");

    /* Full height */
    height: 100%;

    /* Make image center */
    background-position: center center;

    /* Make image fixed */
    background-attachment: fixed;

    /* Not repeat images */
    background-repeat: no-repeat;

    /* Set background size auto */
    background-size: auto;
  }
  .div_left {
    width: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
    margin-left: 0%;
  }
  .div_right {
    display: none;
  }
  .div_left_main {
    padding: 10% 15% 0% 15%;
    width: 100%;
  }
  .div_logo {
    width: 100%;
    margin-top: 5%;
  }

  .div-wrapperimg img {
    position: absolute;
    right: 0;
    bottom: 0;
    display: none;
    width: 40%;
  }
}
@media screen and (orientation: landscape) and (max-width: 1200px) {
  .bge {
    /* The image used */
    background-image: url("../../../../assets/images/background/SpaceDrive – 2.png");

    /* Full height */
    height: 180%;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .div-wrapperimg img {
    display: none;
  }
}
</style>